import React from 'react';
import { Hero } from './components/Hero';
import { Stats } from './components/Stats';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { Volumes } from './components/Volumes';
import { Bonuses } from './components/Bonuses';
import { Countdown } from './components/Countdown';
import { Pricing } from './components/Pricing';
import { Steps } from './components/Steps';
import { FAQ } from './components/FAQ';
import { ValueStack } from './components/ValueStack';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-full w-full overflow-x-hidden text-plum" data-id="element-0" data-mp="31cjpm4rtfv3h">
      <MetaPixel data-id="element-1" data-mp="2wifhhi6tdh0t" />
      <main data-id="element-2" data-mp="2whxaprmizken">
        <Hero data-id="element-3" data-mp="28ufqch5lbolp" />
        <Stats data-id="element-4" data-mp="28u5vaf5our95" />
        <Testimonials data-id="element-5" data-mp="28tmej1rry8wp" />
        <PainPoints data-id="element-6" data-mp="28sutulzptvl7" />
        <Volumes data-id="element-7" data-mp="28sb9kymlev40" />
        <Bonuses data-id="element-8" data-mp="23vchsmqej08z" />
        <Countdown spotsTaken={93} data-id="element-9" data-mp="23vuq4hqc94x9" />
        <Pricing data-id="element-10" data-mp="23utby4e102bb" />
        <Steps data-id="element-11" data-mp="23t8iki3g6pf1" />
        <FAQ data-id="element-12" data-mp="3ijxpqrsp22kf" />
        <Countdown spotsTaken={93} data-id="element-13" data-mp="3ik7e6ay3c1o0" />
        <ValueStack data-id="element-14" data-mp="3ij668fcdfvai" />
      </main>
      <Footer data-id="element-15" data-mp="3ii4t85bsoyq5" />
    </div>;
}